import React from 'react'

import { NextStep } from 'common/builder/components/chart/FlowChart/components/NextStep/NextStep'
import { NodeContainer } from 'common/builder/components/chart/FlowChart/components/Node/components/NodeContainer/NodeContainer'
import { NodeHeader } from 'common/builder/components/chart/FlowChart/components/Node/components/NodeHeader/NodeHeader'
import { NodeStats } from 'common/builder/components/chart/FlowChart/components/Node/components/NodeStats/NodeStats'
import { NodeComponent } from 'common/builder/components/chart/FlowChart/components/Node/types'
import { useFlowChartState } from 'common/builder/components/chart/FlowChart/contexts/FlowChartStateContext'
import { SmartDelayConfig } from 'common/builder/components/chart/FlowChart/nodes/shared/config/index'
import {
  text,
  nodeContentItemColumn,
} from 'common/builder/components/chart/FlowChart/nodes/shared/styles'
import { FlowChartSmartDelayNode } from 'common/builder/components/chart/FlowChart/types/FlowChartNode/FlowChartSmartDelayNode'

export const SmartDelay: NodeComponent<FlowChartSmartDelayNode> = ({
  node: { id, data },
  container,
  builderId,
  disableFlowChartInteractions,
}) => {
  const { isNoStats, isReadonly } = useFlowChartState()
  const { header, nextStep, formatedDelay, stats } = data
  const showStats = !isNoStats && isReadonly && stats.length > 0

  return (
    <NodeContainer
      nodeId={id}
      builderId={builderId}
      container={container}
      disableFlowChartInteractions={disableFlowChartInteractions}
      width={SmartDelayConfig.width}
      highlightColor={SmartDelayConfig.highlightColor}
    >
      <NodeHeader header={header} />
      {showStats && <NodeStats rows={stats} />}
      <view style={nodeContentItemColumn}>
        <richtext text={formatedDelay} style={text} />
      </view>

      {nextStep && <NextStep key={nextStep.id} nextStep={nextStep} />}
    </NodeContainer>
  )
}
